import React from "react";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import red from '@material-ui/core/colors/red';
import green from '@material-ui/core/colors/green';
import { Paper, Grid, Button } from "@material-ui/core";
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import LinkButton from '../../components/linkButton';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import forge from 'node-forge';

import InfoIcon from '@material-ui/icons/Info';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import NHSSettings from './staff/nhs_settings';
import ls from 'local-storage'


const styles = theme => ({
  root: {
    flexGrow: 1,
    overflow: 'hidden',
  },
  button: {
    margin: theme.spacing.unit / 2,
    marginTop: 0,
    marginBottom: 0,
  },
  paper: {
    padding: theme.spacing.unit,
    color: theme.palette.text.secondary,
  },
  tabBar: {
    boxShadow: 'none',
    backgroundColor: '#eaeaea',
    color: 'black',
  },
  icon: {
    margin: theme.spacing.unit,
    fontSize: 48,
  },
  avatar: {
    backgroundColor: red[500],
  },
  newAvatar: {
    backgroundColor: green[500],
  },
  bigAvatar: {
    width: 100,
    height: 100,
  },
});

const sstatedata = {
  active: false,
  api_key: '',
  apptbook_order: '',
  checkin_message: '',
  default_practice: '',
  displayname: '',
  docsname: '',
  forenames: '',
  initials: '',
  email: '',
  jobrole: '',
  last_login: '',
  last_logout: '',
  last_updated: '',
  logged_in: '',
  login_computer: '',
  mobile_pin: '',
  practice_id: '',
  staff_id: '',
  surname: '',
  title: '',
  user_password: '',
  username: '',
  password1: '',
  password2: '',
  nhsedi_alloc: '',
  nhsedi_autopin: '',
  nhsedi_cno: '',
  nhsedi_loc: '',
  nhsedi_ori: '',
  nhsedi_password: '',
  nhsedi_perf: '',
  nhsedi_pin: '',
  nhsedi_username: '',
}

function TabContainer(props) {
  return (
    <Typography component="div">
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

class StaffEdit extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.props = props;

    this.setState({ staffdata: sstatedata });

    this.props.socket.on("staff_details_result", (d) => {

      if (this._isMounted) {
        d.oldusername = d.username;
        this.setState({ staffdata: d });
      }

      //console.log(this.state);
    });

    this.props.socket.on("staff_save_result", (d) => {

      if (this._isMounted) {
        this.setState({ staff_id: d });
        this.setState({ staffdata: sstatedata });
        this.fetchData(this.state.staff_id);
      }

      //console.log(this.state);
    });
  }

  state = {
    staff_id: this.props.match.params.staffid,
    value: 0,
    tabValue: 0,
    stafftype: 'U',
    staffpin: '',
    staffdata: sstatedata,
    showPin: false,
    errorDialogOpen: false,
    deleteDialogOpen: false,
  };

  fetchData(sid) {
    this.setState({ staff_id: sid });
    this.setState({ staffdata: {} });

    if (this._isMounted) {
      this.props.socket.emit("staff_details", { staffid: sid, practice: ls.get('practice'), authenticator: ls.get("authenticator") });
    }
  }

  componentDidMount() {
    this._isMounted = true;

    if (this.state.staff_id) {
      this.fetchData(this.state.staff_id);
      //console.log("staff id");
    } else {
      this.setState({ staffdata: sstatedata });
      //console.log("no staff id");
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleTabChange = (event, tabValue) => {
    this.setState({ tabValue });
  };

  handleTextChange = name => event => {
    let sdatatmp = this.state.staffdata;

    sdatatmp[name] = event.target.value;

    this.setState({ staffdata: sdatatmp });
  };

  closeSnack = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    this.setState({ snackopen: false });
  }

  saveStaff = event => {
    //console.log('save button pressed');
    //console.log(this.state.staffdata);

    if (this.state.staffdata.password1 && this.state.staffdata.password1.trim() !== "") {
      // possible password change
      // make sure password1 and password2 are equal
      // then encrypt the password before sending

      if (this.state.staffdata.password1 !== this.state.staffdata.password2) {
        // show an error
        this.snackbarText = "Both passwords need to be the same."
        this.setState({ snackopen: true });
        return false;
      } else {
        // encrypt password1 and delete password2
        let sdatatmp = this.state.staffdata;

        var md = forge.md.sha256.create();
        md.update(this.state.staffdata.password1);
        //console.log(md.digest().toHex());

        sdatatmp["encpassword1"] = md.digest().toHex();

        this.setState({ staffdata: sdatatmp });
      }
    }
    if (this.state.staffdata.username) {
      let sdatatmp = this.state.staffdata;
      sdatatmp["login_username"] = ls.get("username");
      sdatatmp["practice"] = ls.get('practice');
      this.setState({ staffdata: sdatatmp });

      this.props.socket.emit("staff_save", { staffid: this.state.staffdata, authenticator: ls.get("authenticator") });
    } else {
      this.snackbarText = "Please provide a username for the staff clinician"
      this.setState({ snackopen: true });
    }
  }

  deleteStaff = event => {
    this.setState({deleteDialogOpen: true});
  }

  newStaff = event => {
    this.setState({ staffdata: sstatedata });

    this.props.history.push("/admin/staffedit/");

  }

  deleteYes = e => {
    console.log("delete");
    this.props.socket.emit("staff_delete", { staffid: this.state.staffdata.staff_id, authenticator: ls.get("authenticator") });
    this.setState({deleteDialogOpen: false});
    this.props.history.push("/admin/");
  }

  deleteNo = e => {
    this.setState({deleteDialogOpen: false});
  }

  render() {
    const { classes } = this.props;
    const { tabValue } = this.state;

    return (
      <div className={classes.root}>

        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={this.state.snackopen}
          autoHideDuration={6000}
          onClose={this.closeSnack}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={<span id="message-id"><InfoIcon /> {this.snackbarText}</span>}
          action={[

            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              className={classes.close}
              onClick={this.closeSnack}
            >
              <CloseIcon />
            </IconButton>,
          ]}
        />

        <Dialog
          open={this.state.deleteDialogOpen}
          onClose={this.deleteNo}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Delete Staff"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to delete this staff member?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.deleteNo} color="primary">
              No
            </Button>
            <Button onClick={this.deleteYes} color="primary" autoFocus>
              Yes
            </Button>
          </DialogActions>
        </Dialog>

        <Grid container style={{ padding: 8 }} spacing={1}>
          <Grid item xs={12}>
            <Paper className={classes.paper}>
              <Button variant="contained" color="primary" className={classes.button} onClick={this.saveStaff}>Save</Button>
              <LinkButton variant="contained" color="upload" className={classes.button} to="/admin" text="Cancel" />
              <Button variant="contained" color="secondary" className={classes.button} onClick={this.deleteStaff}>Delete Staff</Button>

              {this.state.staff_id ? <Button variant="contained" style={{ float: "right", backgroundColor: "#00BB00", color: "#FFF" }} className={classes.button} onClick={this.newStaff}>New staff</Button> : null}
            </Paper>
          </Grid>
          <Grid item xs={12} sm={4} md={3}>
            <Paper className={classes.paper}>
              <Grid container spacing={1}>
                {/*<Grid item xs={12}>
                  <Avatar alt={this.state.staffdata.initials} className={classes.bigAvatar}>{this.state.staffdata.initials}</Avatar>
                </Grid>*/}
                <Grid item xs={12}>
                  <FormControl className={classes.formControl} fullWidth={true}>
                    <InputLabel htmlFor="staff-type">Type</InputLabel>
                    <Select
                      value={this.state.staffdata.jobrole}
                      onChange={this.handleTextChange('jobrole')}
                      inputProps={{
                        name: 'stafftype',
                        id: 'staff-type',
                      }}
                    >
                      <MenuItem value="D">Dentist</MenuItem>
                      <MenuItem value="H">Hygienist</MenuItem>
                      <MenuItem value="T">Technician</MenuItem>
                      <MenuItem value="N">Nurse</MenuItem>
                      <MenuItem value="M">Manager</MenuItem>
                      <MenuItem value="R">Receptionist</MenuItem>
                      <MenuItem value="O">Other</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <FormControl className={classes.formControl} fullWidth={true}>
                    <InputLabel htmlFor="staff-title">Title</InputLabel>
                    <Input id="staff-title" placeholder="" value={this.state.staffdata.title}
                      onChange={this.handleTextChange('title')} />
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <FormControl className={classes.formControl} fullWidth={true}>
                    <InputLabel htmlFor="staff-forenames">Forenames</InputLabel>
                    <Input id="staff-forenames" placeholder="" value={this.state.staffdata.forenames}
                      onChange={this.handleTextChange('forenames')} />
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <FormControl className={classes.formControl} fullWidth={true}>
                    <InputLabel htmlFor="staff-surname">Surname</InputLabel>
                    <Input id="staff-surname" placeholder="" value={this.state.staffdata.surname}
                      onChange={this.handleTextChange('surname')} />
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <FormControl className={classes.formControl} fullWidth={true}>
                    <InputLabel htmlFor="staff-displayname">Display name</InputLabel>
                    <Input id="staff-displayname" placeholder="" value={this.state.staffdata.displayname}
                      onChange={this.handleTextChange('displayname')} />
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <FormControl className={classes.formControl} fullWidth={true}>
                    <InputLabel htmlFor="staff-docsname">Docs name</InputLabel>
                    <Input id="staff-docsname" placeholder="" value={this.state.staffdata.docsname}
                      onChange={this.handleTextChange('docsname')} />
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <FormControl className={classes.formControl} fullWidth={true}>
                    <InputLabel htmlFor="staff-initials">Initials</InputLabel>
                    <Input id="staff-initials" placeholder="" value={this.state.staffdata.initials}
                      onChange={this.handleTextChange('initials')} />
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <FormControl className={classes.formControl} fullWidth={true}>
                    <InputLabel htmlFor="staff-email">Email Address</InputLabel>
                    <Input id="staff-email" placeholder="" value={this.state.staffdata.email}
                      onChange={this.handleTextChange('email')} />
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <FormControl className={classes.formControl} fullWidth={true}>
                    <InputLabel htmlFor="staff-username">Username (without @practice)</InputLabel>
                    <Input id="staff-username" placeholder="" value={this.state.staffdata.username}
                      onChange={this.handleTextChange('username')} />
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <FormControl className={classes.formControl} fullWidth={true}>
                    <InputLabel htmlFor="staff-password1">Password</InputLabel>
                    <Input id="staff-password1" type="password" value={this.state.staffdata.password1}
                      onChange={this.handleTextChange('password1')} />
                  </FormControl>
                  <FormHelperText>Only enter a password if you intend to change it</FormHelperText>
                </Grid>
                <Grid item xs={12}>
                  <FormControl className={classes.formControl} fullWidth={true}>
                    <InputLabel htmlFor="staff-password2">Password again</InputLabel>
                    <Input id="staff-password2" type="password" value={this.state.staffdata.password2}
                      onChange={this.handleTextChange('password2')} />
                  </FormControl>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={1} md={9}>
            <AppBar position="static" className={classes.tabBar}>
              <Tabs value={tabValue} onChange={this.handleTabChange}>
                <Tab label="NHS Settings" />
              </Tabs>
            </AppBar>
            {tabValue === 0 && <TabContainer><NHSSettings staffdata={this.state.staffdata} /></TabContainer>}
          </Grid>
        </Grid>

      </div>
    );
  }
}

export default withStyles(styles)(StaffEdit);